/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import {
  getColor,
  getShape,
  pd,
} from '@airasia-phoenix/react-native/utils/utils';
import { SWAP_BUTTON_SIZE } from '../../configs/constants';

/**
 * Bottom-sheet sizing PROPS (not styles). Kept outside the unistyles sheet on
 * purpose: on web, unistyles v3 exposes sheet values as non-enumerable
 * properties, so spreading `styles.x` into props copies nothing and the sheet
 * opened with no height.
 */
export const DESTINATION_SHEET_HEIGHT = {
  initialHeight: '80%',
  finalHeight: '80%',
  height: '100%',
} as const;

export const styles = StyleSheet.create((pd) => ({
  container: {
    paddingBottom: 0,
    backgroundColor: getColor(pd.sys.colour.bg_primary),
    overflow: 'visible',
    marginBottom: 0,
    width: '100%',
    alignSelf: 'center',
  },
  stationRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: pd.ref.space.spacing10.px,
    marginBottom: 0,
    position: 'relative',
    zIndex: 10,
    minHeight: 0,
    overflow: 'visible',
  },
  fieldWrapper: {
    flex: 1,
    position: 'relative',
    zIndex: 0,
  },
  swapOverlay: {
    position: 'absolute',
    zIndex: 2,
    left: '50%',
    top: '50%',
    transform: [
      { translateX: -SWAP_BUTTON_SIZE / 2 },
      { translateY: -SWAP_BUTTON_SIZE / 2 },
    ],
  },
  swapButton: {
    borderColor: getColor(pd.sys.colour.outline_low),
    backgroundColor: getColor(pd.sys.colour.container_low),
    height: SWAP_BUTTON_SIZE,
    width: SWAP_BUTTON_SIZE,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: SWAP_BUTTON_SIZE / 2,
  },
  searchButtonContainer: {
    marginTop: pd.ref.space.spacing40.px,
    zIndex: 1,
    // width: 328,
    // height: 48,
  },
  rowDouble: {
    flexDirection: 'row',
    gap: pd.ref.space.spacing40.px,
    marginBottom: pd.ref.space.spacing40.px,
  },
  halfWidth: {
    flex: 1,
  },
  skeletonFull: {
    width: '100%',
    height: 56,
    ...getShape(pd.sys.shape.corner.small),
  },
  skeletonHalf: {
    width: '100%',
    height: 72,
    ...getShape(pd.sys.shape.corner.small),
  },
  sheetHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: pd.ref.space.spacing20.px,
    paddingTop: pd.ref.space.spacing10.px,
    paddingBottom: pd.ref.space.spacing10.px,
    gap: pd.ref.space.spacing10.px,
  },
  sheetCloseButton: {
    paddingTop: pd.ref.space.spacing20.px,
    paddingLeft: pd.ref.space.spacing20.px,
    paddingRight: pd.ref.space.spacing10.px,
  },
  sheetInputWrapper: {
    flex: 1,
    paddingTop: pd.ref.space.spacing40.px,
    paddingLeft: pd.ref.space.spacing10.px,
    paddingRight: pd.ref.space.spacing30.px,
  },
  sheetListContainer: {
    flex: 1,
    paddingTop: pd.ref.space.spacing30.px,
    paddingBottom: pd.ref.space.spacing30.px,
  },
  spinnerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: pd.ref.space.spacing40.px,
  },
  popularSearchesContainer: {
    paddingHorizontal: pd.ref.space.spacing40.px,
    paddingTop: pd.ref.space.spacing20.px,
    paddingBottom: pd.ref.space.spacing40.px,
  },
  popularSearchesTitle: {
    marginBottom: pd.ref.space.spacing30.px,
  },
}));
